 import React, {useState, useEffect ,useRef} from "react";
import {APP_URL, IMG_URL, amount_format,discount} from '../components/config/Common'
// import Swiper core and required modules
import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'

import { BiRupee } from "react-icons/bi";
import { motion as ms } from 'framer-motion';
import {Links} from '../routes/PathLink'
import CathLabRange from './CathLabRange2'
import { LazyLoadImage, LazyLoadComponent } from 'react-lazy-load-image-component';
import { Link } from "react-router-dom";
import {ChevronLeft, ChevronRight, Loading} from "../custom-icons";


import 'swiper/css'; 
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

const catBreakpoints = {
   320: {
     slidesPerView: 1,
   },
   510: {
     slidesPerView: 1,
   },
   600: {
      slidesPerView: 2,
   },
   950: {
      slidesPerView: 5,
   },
   1300: {
     slidesPerView: 5,
   },
};


const CategoryRangeHome = ({
   category
}) => {

   const [user_type, setUser_type] = useState('')

    useEffect(() => {
      
         const user_type = localStorage.getItem('user_type');
         setUser_type(user_type);
      
    }, [])
    const upPrevRef = useRef();
    const upNextRef = useRef();

   

   return (
     
     <div className="bg-light py-10 px-5 md:px-5 border-b-2 border-accent">
         <h3 className="text-center text-4xl text-accent mt-4 mb-3 uppercase">Our <span className="bg-accent text-white px-2">Other</span> Equipment Range</h3>
                 <div className="relative px-10 ">
                  <Swiper
                     // install Swiper modules
                     modules={[Navigation, Thumbs, Autoplay]}
                     id="productGallery-122"
                     spaceBetween={20}
                     watchSlidesProgress={true}
                     freeMode={true}
                     observer={true}
                     observeParents={true}
                     breakpoints={catBreakpoints}
                     style={{paddingLeft:15,paddingRight:15}}
                     loop={true}
                     autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                     }}

                     navigation={{
                        prevEl: upPrevRef.current, // Assert non-null
                        nextEl: upNextRef.current, // Assert non-null
                     }}
                  >
                  {
                     category.map((val,key) => (
                        <SwiperSlide className="my-5">
                          
                              <Link to={`${Links.CATEGORY}/${val?.slug}`} className="text-heading text-orange-500 text-md">
                              
                                 <div className="shadow-md shadow-accent flex flex-col items-center justify-center gap-1 rounded">
                                    <div class="w-1/2 h-28 object-cover overflow-hidden">
                                       <img src={`${IMG_URL}${val?.cat_image}`} className="py-1 h-28 object-cover"/>
                                    </div>
                                    <div class="text-base text-accent text-center py-2 truncate w-full px-3">{val.cat_name}</div>
                                    </div>
                              </Link>
                         
                        </SwiperSlide>
                     ))
                  }
                  
                  </Swiper>


                  <div
                  ref={upPrevRef}
                  className="product-gallery-prev absolute top-2/4 z-10 -mt-4 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-accent text-light transition-all duration-200 md:-mt-5 md:h-9 md:w-9 left-0"
                  >
                     <ChevronLeft className="h-4 w-4" />
                  </div>   
               <div
                  ref={upNextRef}
                  className="product-gallery-next absolute top-2/4 z-10 -mt-4 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-accent text-light transition-all duration-200 md:-mt-5 md:h-9 md:w-9 right-0"
                  >
                     <ChevronRight className="h-4 w-4" />
               </div>

               </div>
       </div>                                                                                                
   )
}

export default CategoryRangeHome;                                                                                                                                                                                                                                                                                          